/* eslint-disable @typescript-eslint/no-explicit-any */
import { signal } from '@preact-signals/safe-react'

import { _doFetch } from './do-fetch'
import { _FetchConfigData, _RequestDefinition } from './types'

const isLoading = signal<Record<string, boolean>>({})

export const _createFetchClient =
  (fetchConfigData: _FetchConfigData) =>
  <Def extends _RequestDefinition<any, any, any>>(def: Def) => {
    let controller: AbortController | null = null

    async function fetchFn(params?: {
      urlParams?: Def['urlParams']
      fetchParams?: Def['fetchParams']
    }): Promise<Def['response']> {
      controller = new AbortController()
      isLoading.value = { ...isLoading.value, [def.url]: true }
      try {
        const res = await _doFetch(fetchConfigData)(def, {
          ...params,
          signal: controller.signal
        })
        return res
      } catch (err) {
        throw err
      } finally {
        isLoading.value = { ...isLoading.value, [def.url]: false }
      }
    }

    return {
      fetch: fetchFn,
      abort: () => controller?.abort(),
      isLoading: isLoading.value[def.url]
    }
  }
